import { render, staticRenderFns } from "./MosaicNavigation.vue?vue&type=template&id=5bdde0f0&scoped=true&"
import script from "./MosaicNavigation.vue?vue&type=script&lang=js&"
export * from "./MosaicNavigation.vue?vue&type=script&lang=js&"
import style0 from "./MosaicNavigation.vue?vue&type=style&index=0&id=5bdde0f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdde0f0",
  null
  
)

export default component.exports